<template>
  <dx-popover
    :position="model.position"
    :width="model.width"
    :visible.sync="model.visible"
    :target="model.target"
    :ref="model.ref"
  >
    <div v-show="model.loaderVisible" class="text-center">
      <dx-load-indicator
        height="20"
        width="20"
      />
      <h4 class="no-margin">Laster...</h4>
    </div>

    <div v-show="model.error.visible">
      <h4 class="no-margin">{{model.error.title}}</h4>
      <p class="no-margin">{{model.error.description}}</p>
    </div>

    <div v-show="!model.loaderVisible && !model.data.length && !model.error.visible">
      <slot name="nodata">
        <h4 class="no-margin">Ingen data</h4>
        <p class="no-margin">Det finnes ingen data på valgt måler</p>
      </slot>
    </div>

    <div v-show="!model.loaderVisible && model.data.length">
      <slot></slot>
    </div>
  </dx-popover>
</template>

<script>
  import DxPopover from 'devextreme-vue/popover';
  import DxLoadIndicator from 'devextreme-vue/load-indicator';
  import {dateService} from '@entro-no/common';

  export default {
    name: 'ElhubPopover',
    props: ['model'],
    components: {
      DxPopover,
      DxLoadIndicator
    },
    methods: {
      getDateString(value) {
        return dateService.getDateString(value);
      },
      update(targetElem, requestPromise) {
        const model = this.model || {};
        model.error.visible = false;

        if (model.visible) {
          model.visible = false;
        } else {
          model.data          = [];
          model.target        = targetElem;
          model.loaderVisible = true;

          // DevExtreme needs time to bind target before setting visible = true
          setTimeout(() => model.visible = true, 250);

          requestPromise().then(data => {
            this.elem.beginUpdate()
            model.data = data;
          }).catch(error => {
            model.error = {
              visible:      true,
              title:        'En feil oppstod',
              description:  `Kunne ikke hente data (Feilkode ${error ? error.status : '?'})`
            };
          }).finally(() => {
            model.loaderVisible = false;
            setTimeout(() => this.elem.repaint(), 0)
            setTimeout(() => this.elem.endUpdate(), 800)
          });
        }
      }
    },
    computed: {
      elem: function () {
        return this.$refs[this.model.ref].instance;
      }
    }
  };
</script>

<style scoped>

</style>
